module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "Basic-Paragraph para-style-override-2"
  }), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph para-style-override-12"
  }, [_c('span', {
    staticClass: "char-style-override-6"
  }, [_vm._v("And Cain talked with Abel his brother: and it came to pass, when they were in the field, that Cain rose up against Abel his brother, and slew him.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph para-style-override-13"
  }, [_vm._v("—Genesis 4:8")]), _vm._v(" "), _c('p', {
    staticClass: "x-2-chapter para-style-override-3"
  }), _vm._v(" "), _c('p', {
    staticClass: "x-1-title"
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3fd99973","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/SIDP_FM01_0003_0001.vue
// module id = 69
// module chunks = 0